import Link from 'next/link';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import ReactPlayer from 'react-player/lazy';
import ProfileCard from '../../shared/shared-card/ProfileCard';
import Share from '../../shared/Share';

const SuccessDetail = ({ storyData }) => {
  return (
    <>
      <div className="flex flex-col">
        <div className="realtive flex flex-row justify-between">
          <div className="mx-5 mt-8 flex">
            <div>
              <h2 className="mb-4 lg:w-[85%]">{storyData?.title}</h2>
              <div className="mb-8 text-justify text-base lg:w-[85%]">{storyData?.tagline}</div>
              <div className="player-wrapper">
                {storyData?.videoLink && (
                  <>
                    <div
                      className="react-player hidden lg:block"
                      style={{ width: '100%', height: '100%' }}
                    >
                      <ReactPlayer url={storyData?.videoLink} controls height={380} />
                      <br />
                      <br />
                    </div>
                    <div
                      className="react-player lg:hidden"
                      style={{ width: '100%', height: '100%' }}
                    >
                      <ReactPlayer url={storyData?.videoLink} controls width="100%" height={240} />
                      <br />
                      <br />
                    </div>
                  </>
                )}
              </div>
              <ReactMarkdown
                components={{
                  h1: (props) => <h1 {...props} className="mb-4 text-justify text-xl" />,
                  p: (props) => <p {...props} className="mb-8 text-justify text-base lg:w-[85%]" />,
                  a: ({ node, href, children, ...props }) => (
                    <a {...props} href={href}>
                      <a className="text-base text-blue hover:underline">{children}</a>
                    </a>
                  ),
                  ul: ({ node, ...props }) => <ul {...props} className="list-inside list-disc" />,
                  strong: ({ node, ...props }) => (
                    <span {...props} className="font-satoshi-bold text-base font-bold " />
                  ),
                  li: ({ node, ...props }) => <li {...props} className="text-base" />,
                  ol: ({ node, ...props }) => (
                    <ol
                      {...props}
                      className="mb-4 list-inside list-decimal font-satoshi-bold font-bold "
                    />
                  ),
                }}
                remarkPlugins={[remarkGfm]}
              >
                {storyData?.description}
              </ReactMarkdown>
              <div className="block lg:hidden">
                <Share slug={`/success-stories/${storyData?.slug}`} />
                <div
                  className="mb-6"
                  style={{
                    border: '0.025rem solid #DCDCDC',
                    background: '#DCDCDC',
                  }}
                ></div>
              </div>
              <ProfileCard
                image={storyData?.avatar}
                name={storyData?.studentName}
                designation={storyData?.studentDesignation}
                linkedinUrl={storyData?.linkedinUrl}
                companyLogo={storyData?.companyLogo}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SuccessDetail;
